import React, { useEffect } from "react";
import TourPackageData from "./TourPackageData.js";
import TravelCard from "./TravelCard";
import { useLocation } from 'react-router-dom';
import heroImg from '../../assets/Banner.png';
import { Helmet } from "react-helmet";


const TourPackages = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>India Tour & Travel Services – One Way Cab, Sightseeing, Hotel Stays</title>
        <meta
          name="description"
          content="Hire a cab in Jaipur for sightseeing, weekend getaways, and family tours. We offer reliable outstation taxi service across Rajasthan & North India."
        />
        <meta
          name="keywords"
          content="India tour packages, Rajasthan taxi service, Jaipur sightseeing, weekend getaways, family tours, one way cab, outstation taxi, taxi service Rajasthan, North India travel"
        />
      </Helmet>
      <section className="relative  h-[30vh] sm:h-[60vh] w-full mt-[70px]">
        <img
          src={heroImg}
          alt="About Hero"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-pink-600/80 to-pink-500/80"></div>
        <div className="relative z-10 flex flex-col items-center justify-center h-full text-white px-4 sm:px-10 md:px-20 text-center">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold font-serif">Tour Packages</h1>
          <p className="text-lg sm:text-xl md:text-2xl mt-4 max-w-3xl">
            Custom travel plans for unforgettable journeys across Rajasthan and incredible India
          </p>
        </div>
      </section>
      <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-6 p-6 mt-20 ">
        {TourPackageData.map((destination, index) => (
          <TravelCard
            key={destination.id}
            index={index}
            title={destination.title}
            description={destination.desc}
            image={destination.image}
            include={destination.include}
          />
        ))}
      </div>
    </>

  );
};

export default TourPackages;

// import React from "react";
// import TourPackageData from "./TourPackageData.js";
// import TravelCard from "./TravelCard";

// const TourPackages = () => {
//   return (
//     <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-6 p-6 mt-20 ">
//       {TourPackageData.map((destination, index) => (
//         <TravelCard
//           key={destination.id}
//           index={index}
//           title={destination.title}
//           description={destination.desc}
//           image={destination.image}
//           include={destination.include}
//         />
//       ))}
//     </div>
//   )
// }
// export default TourPackages;